// test1025
(1025 && 0);
